export default "https://skrwd-shindan.herokuapp.com/packs/media/images/support_illust_01-656b2ee0876182b936099c87ddafacce.png";